import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { GenreSimpleFormContent } from "./components/GenreSimpleFormContent";

export function GenreCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <GenreSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
